/** ***********************************************************************
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

import React, { Component } from 'react';
import { Switch, Route } from 'react-router';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import SideNav from '../../../components/sidenav';
import Catalog from '../../../components/catalog';
import PDP from '../../../components/pdp';
import TranslationUtil from '../../../utils/translation';
import AppConfig from '../../../stores/config';
import './skeleton.scss';

class SkeletonLayout extends Component {
    componentWillMount() {
        const { intl } = this.props;
        TranslationUtil.setIntl(intl);
    }

    componentDidMount() {
        const { intl } = this.props;
        TranslationUtil.setIntl(intl);
    }

    render() {
        const { props } = this;
        const { apps, appsPanelSkeleton, appConfig } = props;
        AppConfig.init({
            showDownloadError: appConfig.showDownloadError,
            isMasked: appConfig.isMasked,
            isNonDownloadableSurface: appConfig.isNonDownloadableSurface,
            shortHeight: appConfig.shortHeight,
            noBanner: appConfig.noBanner,
            dialogManager: appConfig.dialogManager,
            layouts: appConfig.layouts,
            getPDPDataCallback: appConfig.getPDPDataCallback,
            analyticsCallback: appConfig.analyticsCallback,
            appReloadCallback: appConfig.appReloadCallback,
            linkCallbacks: appConfig.linkCallbacks,
            proceedAsAdminCallback: appConfig.proceedAsAdminCallback,
            relaunchCallback: appConfig.relaunchCallback,
            pdpAssetsBasePath: appConfig.pdpAssetsBasePath,
            isOnline: appConfig.isOnline,
            shouldWrapAtLowerBP: appConfig.shouldWrapAtLowerBP,
        });
        return (
            <div className="cc-apps-skeleton">
                <SideNav
                    appsPanelSkeleton={appsPanelSkeleton}
                    apps={apps}
                    {...props}
                />
                <Switch>
                    <Route
                        path={`${props.match.path}/:sectionId/:subSectionId/pdp/:productId`}
                        render={routeProps => (
                            <PDP
                                routeParams={routeProps.match.params}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        render={() => (
                            <Catalog
                                {...props}
                            />
                        )}
                    />
                </Switch>
            </div>
        );
    }
}

SkeletonLayout.propTypes = {
    match: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
};

export default observer(SkeletonLayout);
